(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raitooe-accessories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('raitooe-accessories')) {
    customElements.define('raitooe-accessories', class extends HTMLElement {
      connectedCallback() {
        this.onClick = (event) => {
          const button = event.target.closest('[data-category]');
          if (button && this.contains(button)) this.activate(button.dataset.category);
        };
        this.onBlockSelect = (event) => {
          const button = this.querySelector(`[data-category="${CSS.escape(event.detail.blockId)}"]`);
          if (button) this.activate(button.dataset.category);
        };
        this.addEventListener('click', this.onClick);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        const navigation = this.querySelector('[data-category-nav]');
        if (navigation) navigation.hidden = false;
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
      activate(category) {
        this.querySelectorAll('[data-category]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.category === category)));
        this.querySelectorAll('[data-category-panel]').forEach((panel) => { panel.hidden = panel.dataset.categoryPanel !== category; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wjs_product_content_arrangement"] && !Shopify.designMode) return;
  try {
    
  // Delegated so it keeps working when the section is added more than once.
  if (!window.__pcaSoundToggle) {
    window.__pcaSoundToggle = true;
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('[data-pca-sound]');
      if (!button) return;
      const wrapper = button.closest('.pca-video');
      if (!wrapper) return;
      const muted = button.dataset.muted !== 'true';
      for (const video of wrapper.querySelectorAll('video')) video.muted = muted;
      button.dataset.muted = String(muted);
      button.setAttribute('aria-label', muted ? '音声をオンにする' : '音声をオフにする');
    });
  }

  } catch(e) { console.error(e); }
})();
})();
